import React, { Component } from "react";
import profile from "../../../assets/images/Oval.png";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import postService from "../../../services/httpService";

class VitalsTvDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      QueueList: [],
    };
  }
  componentDidMount() {
    this.getDoctorDetails();
  }

  getDoctorDetails() {
    postService("getVitalQueuePatients", "POST", {
      data: { work_station: "1CS1" },
    }).then((res) => {
      
      if (res) {
        this.setState({
          QueueList: res.data,
        });
      }
    });
  }

  render() {
    const { QueueList } = this.state;

    return (
      <div className="tv-counter-data">
        <div className="py-3 counter-card h-100 col-12">
          <div className="row">
            <div className="col-12">
              <div className="col-12 reports-details counter-details">
                <div className="card">
                  <table>
                    <thead>
                      <tr className="row head-row">
                        <th className="col my-auto">Nurse Name</th>
                        <th className="col my-auto">Patient Name</th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="card">
                  <table className="table-body">
                    <tbody>
                      {QueueList.map((item) => (
                        <tr className="row tv-row">
                          <td className={"col my-auto order-1"}>
                            Vitals nurse 1
                            <br />
                            N1
                          </td>
                          <td className={"col my-auto order-1"}>
                            <div className="token">{item.name}</div>{" "}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default VitalsTvDisplay;
